import { Component } from '@angular/core';
import { ReportShareComponent } from '../report-share.component';

@Component({
  selector: 'app-least-style',
  templateUrl: './least-style.component.html'
})
export class LeastStyleComponent extends ReportShareComponent {

  get html(): string {
    return this.report?.leastDevCoachingStyleDesc?.replaceAll("\n", "<br />") ?? '';
  }

  private getStyleText(): { header: string; heading: string; line: string } {
    if (this.isFacilitatorTemplate) {
      return {
        header: 'AREAS OF IMPROVEMENT',
        heading: 'Your Least Developed Facilitator Style',
        line: 'Your least used facilitator style is the',
      };
    } else if (this.isCoachingStyles) {
      return {
        header: 'LEAST PREFERRED',
        heading: `Least Preferred Coaching Style from ${this.report?.name || '...'}`,
        line: 'Their least preferred coaching style from you is the',
      };
    } else if (this.isDirectReport) {
      return {
        header: 'DIRECT REPORT STYLE PREFERENCE',
        heading: 'Least Preferred Style for Direct Report',
        line: 'Their least preferred style from you is the',
      };
    } else if (this.isPeerToPeer) {
      return {
        header: 'PEER-TO-PEER STYLE PREFERENCE',
        heading: 'Least Preferred Style in Peer-to-Peer Interaction',
        line: 'Their least preferred style from you in peer-to-peer interaction is the',
      };
    } else if (this.isCoacheePreference) {
      return {
        header: 'LEAST PREFERRED',
        heading: `Least Preferred Coaching Style from You - ${this.report?.name || '...'}`,
        line: 'Their least preferred coaching style from you is the'
      };
    }
    return {
      header: 'UNKNOWN TEMPLATE',
      heading: 'No specific heading available',
      line: 'No summary available',
    };
  }

  get improvementHeader(): string {
    const { header } = this.getStyleText();
    return header;
  }

  get improvementHeading(): string {
    const { heading } = this.getStyleText();
    return heading;
  }

  get summaryLine(): string {
    const { line } = this.getStyleText();
    return line;
  }
}
